import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RequestService } from '@df/api/request/request.service';
import { App } from '@df/core/app';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsComponent, ICmsContent, NICmsContentComponent } from '@icms/core/content';
export interface IPageComponentAddThisData extends NICmsContentComponent.IData {
    data_url: string;
}
@Component({
    selector: 'add-this',
    template: '<div [ngClass]="className"></div>',
    standalone: true,
    imports: [NgClass],
    styles: [
        `
            :host {
                display: block;
                min-height: 31px;
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
@ICmsComponent<PageComponentAddThisComponent>({
    id: 'add-this',
    name: 'Add This Widget',
    hidePreview: true,
    fields: [],
    tags: ['product view', 'widget']
})
export class PageComponentAddThisComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    @ICmsContent({
        type: 'component'
    })
    component: IPageComponentAddThisData;

    constructor(
        private requestService: RequestService,
        private app: App
    ) {
        super();
    }

    private scriptUrl = 'https://platform-api.sharethis.com/js/sharethis.js#property=64f86f77a6e78100191d5d8a&product=sop';

    private get isPlatformBrowser() {
        return this.app.isPlatformBrowser;
    }

    protected get className(): string {
        return this.isPlatformBrowser ? 'sharethis-inline-share-buttons' : '';
    }

    override ngOnInit(): void {
        super.ngOnInit();
        this.load();
        if (this.isPlatformBrowser) {
            this.subscriptions.add(this.client.obs.breakpoint.subscribe(() => this.refresh()));
            this.refresh();
        }
    }
    private refresh(): void {
        const sharethis = window['__sharethis__'];
        if (sharethis) {
            sharethis?.initialize();
        }
    }

    private load() {
        if (this.isPlatformBrowser) {
            window['prqAppLoaded'] = undefined;
            if (this.app.isPlatformBrowser) {
                return new Promise((resolve, reject) => {
                    this.requestService.loadScript(this.scriptUrl, { reload: true });
                });
            }
        }
    }
}
